export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 1_01.f6921c76.jpg";